import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    dateCreated: string;
    name: string;
    sortBy: string;
    sortByLabel: (label?: string) => string | React.ReactNode;
    sortByOrderLabel: {
        default: {
            /** Sort order label for sorting project names A to Z */
            asc: string;
            /** Sort order label for sorting project names Z to A */
            desc: string;
        };
        created_at: {
            /** Sort order label for sorting by creation date from oldest to newest */
            asc: string;
            /** Sort order label for sorting by creation date from newest to oldest */
            desc: string;
        };
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu label for sorting by Date Created */
            dateCreated: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.dateCreated?c=2kb8fcug33grf", defaultMessage: "Date Created" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu label for sorting by name */
            name: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.name?c=225ge594d9ejj", defaultMessage: "Name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group label for sorting options in the project switcher sheet */
            sortBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.sortBy?c=2wblap6k3irjd", defaultMessage: "Sort by" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for the sort button, including the currently selected sort field */
            sortByLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (label?: string) => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.sortByLabel?c=345mw9e1txj9o", defaultMessage: "Sort by {label}" }, { label: label }));
                },
                enumerable: true,
                configurable: true
            },
            sortByOrderLabel: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        default: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Sort order label for sorting project names A to Z */
                                    asc: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.sortByOrderLabel.default.asc?c=2cff77fqrna8", defaultMessage: "from A \u2192 Z" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Sort order label for sorting project names Z to A */
                                    desc: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.sortByOrderLabel.default.desc?c=ol9uonm73nsp", defaultMessage: "from Z \u2192 A" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        created_at: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Sort order label for sorting by creation date from oldest to newest */
                                    asc: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.sortByOrderLabel.created_at.asc?c=5sowizhqr5ys", defaultMessage: "from Oldest \u2192 Newest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Sort order label for sorting by creation date from newest to oldest */
                                    desc: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSort.sortByOrderLabel.created_at.desc?c=1u4yu4c4dkus8", defaultMessage: "from Newest \u2192 Oldest" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
